var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeoTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338,
    height: 221.428,
    viewBox: "0 0 338 221.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3111",
    "data-name": "Group 3111",
    transform: "translate(-1897 -2545)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 53.767,
    height: 204.939,
    transform: "translate(2173.995 2561.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1653",
    "data-name": "Rectangle 1653",
    width: 53.767,
    height: 204.939,
    transform: "translate(2119.995 2561.489)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2_4_5_7_10_14",
    "data-name": "2 4 5 7 10 14",
    transform: "translate(2145 2582.581)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 34.5
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 69
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 103.5
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.861,
    y: 138
  }, "10"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.861,
    y: 172.5
  }, "14")), /*#__PURE__*/React.createElement("text", {
    id: "_1_2_3_5_6",
    "data-name": "1 2 3 5 6",
    transform: "translate(2201 2582.581)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 34.5
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 69
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 103.5
  }), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 138
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 172.5
  }, "6")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 53.67,
    height: 32.593,
    transform: "translate(2173.995 2666.328)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1654",
    "data-name": "Rectangle 1654",
    width: 53.67,
    height: 32.593,
    transform: "translate(2119.995 2666.328)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("text", {
    id: "River_City_Dental",
    "data-name": "River City Dental",
    transform: "translate(1908.696 2752.75)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "River City Dental")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(2201 2686.841)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.442,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M0,0H330.934V204.793H0Z",
    transform: "translate(1897.268 2561.488)",
    fill: "none",
    stroke: "#babcbf",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "Overall_Rank:",
    "data-name": "Overall Rank:",
    transform: "translate(2201 2554)",
    fill: "#a7a9ac",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.335,
    y: 0
  }, "OVERALL RANK:")), /*#__PURE__*/React.createElement("text", {
    id: "Avg:",
    transform: "translate(2145 2554)",
    fill: "#a7a9ac",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.993,
    y: 0
  }, "AVG:")), /*#__PURE__*/React.createElement("text", {
    id: "Riverton_Heights_Dental_Care",
    "data-name": "Riverton Heights Dental Care",
    transform: "translate(1925.033 2686.581)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Riverton Heights Dental Care")), /*#__PURE__*/React.createElement("text", {
    id: "Stone_Creek_Family_Dental",
    "data-name": "Stone Creek Family Dental",
    transform: "translate(1926.764 2583.179)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Stone Creek Family Dental")), /*#__PURE__*/React.createElement("text", {
    id: "Riverton_Dental",
    "data-name": "Riverton Dental",
    transform: "translate(1908.764 2617.778)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Riverton Dental")), /*#__PURE__*/React.createElement("text", {
    id: "Abundant_Dental_Care_and_Implants",
    "data-name": "Abundant Dental Care and Implants",
    transform: "translate(1908.764 2653.376)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abundant Dental Care and Implants")), /*#__PURE__*/React.createElement("text", {
    id: "Silver_Ridge_Dental_Care",
    "data-name": "Silver Ridge Dental Care",
    transform: "translate(1908.764 2718.975)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Silver Ridge Dental Care")), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 330.971,
    transform: "translate(1897.231 2596.418)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x2: 330.971,
    transform: "translate(1897.231 2630.945)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x2: 330.971,
    transform: "translate(1897.231 2665.472)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x2: 330.971,
    transform: "translate(1897.231 2734.998)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 4.648,
    cy: 4.648,
    r: 4.648,
    transform: "translate(1909.875 2574.049)",
    fill: "#74ad85"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 4.648,
    cy: 4.648,
    r: 4.648,
    transform: "translate(1909.875 2677.495)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": 7,
    transform: "translate(2145 2687.354)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.442,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    id: "Competitors:",
    transform: "translate(1899.372 2554)",
    fill: "#a7a9ac",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "COMPETITORS:")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1485",
    "data-name": "Rectangle 1485",
    transform: "translate(1897 2666)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 33,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 330,
    height: 32,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoTable);
export default __webpack_public_path__ + "static/media/seoTable.d3f2a0fe.svg";
export { ForwardRef as ReactComponent };